import React, {useState} from 'react'
import {Rect, Text, Transformer} from "react-konva";

let SELECTION_RECTANGLE: any = {
    fill: 'rgba(148,163,184,0.25)',
    visible: false,
}

const ImageTransformer = ({transformerRef}) => {
    // const [selectionRectangleAttrs, setSelectionRectangleAttrs] = useState(SELECTION_RECTANGLE);

    return (
        <>
            <Transformer
                ref={transformerRef}
                boundBoxFunc={(oldBox, newBox) => {
                    if (newBox.width < 5 || newBox.height < 5) {
                        return oldBox;
                    }
                    return newBox;
                }}
            />

            {/*<Rect
                ref={selectionRectangleRef}
                {...selectionRectangleAttrs}
            />*/}
        </>
    )
}

export default ImageTransformer
